import type { JSX } from 'react'

/**
 * Shows the shape of the method list while the terminal waits.
 * @returns The loading skeleton.
 */
export function LoadingScreen(): JSX.Element {
  return (
    <>
      <section
        role="status"
        aria-label="Loading payment methods"
        data-testid="terminal-loading"
        className="flex flex-col gap-3"
      >
        <span className="sr-only">{'Loading payment methods'}</span>
        <h2
          className="blytz-drawer__title"
          aria-hidden="true"
          data-testid="terminal-loading-heading"
        >
          <span className="terminal-skeleton__shape terminal-skeleton__line terminal-skeleton__line--title" />
        </h2>
        <ul className="flex flex-col gap-3" aria-hidden="true">
          {[0, 1].map(row => (
            <li key={row}>
              <div
                data-testid="terminal-loading-card"
                className="blytz-card blytz-card--selectable w-full"
              >
                <span className="blytz-pm__label block">
                  <span className="terminal-skeleton__shape terminal-skeleton__line" />
                </span>
                <span className="blytz-pm__meta block">
                  <span className="terminal-skeleton__shape terminal-skeleton__line terminal-skeleton__line--meta" />
                </span>
              </div>
            </li>
          ))}
        </ul>
        <div
          data-testid="terminal-loading-button"
          aria-hidden="true"
          className="blytz-btn blytz-btn--full terminal-skeleton__shape"
        />
      </section>
      <CancelSpacer />
    </>
  )
}

/**
 * Holds the height of the Cancel row while that row is hidden.
 * @returns An invisible copy of the Cancel link.
 */
export function CancelSpacer(): JSX.Element {
  return (
    <div
      data-testid="terminal-cancel-spacer"
      className="flex justify-center invisible"
      aria-hidden="true"
    >
      <span className="blytz-btn blytz-btn--link">{'Cancel'}</span>
    </div>
  )
}
